// extracted by mini-css-extract-plugin
module.exports = {"light_ui-checkbox-label-color":"#070d17","light_ui-radio-border-color":"#d1d1d1","dark_ui-checkbox-label-color":"#fff","dark_ui-checkbox-border-color":"#757575"};